module.exports = __webpack_public_path__ + "img/trash.c43c25c1.svg";